import React from 'react';

import PropTypes from 'prop-types';
import { Button, Divider, Notification, Typography } from '@telus-uds/components-web';
import Download from '@telus-uds/palette-allium/build/web/icons/Download';

import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import request from '../../../utils/request';
import Attachements from './attachements';
import { CONSTANT } from '../../../utils/constant';

const OrderAttachments = ({ links, orderData, hideQuote }) => {
  const localizedString = useLocalizedStringsContext();
  const {
    ORDERS: { quotePdf, contractUnSigned, contractSignedPdf, attachments },
    productInOrderForOptions: { microsoft365, googleWorkspace, esChat },
    BUSINESS_APP_ORDERS: { attachementNote },
    USERS: {
      USER_AUTHENTICATION: {
        labels: { NOTE }
      }
    },
    contentfulValues: { no }
  } = localizedString;
  const {
    KEYS: {
      ROLES: { ADMIN, SALES_REP, SALES_MANAGER, SALES_SUPPORT }
    }
  } = CONSTANT;

  const {
    role: { name: roleId }
  } = request.getProfile();
  const uploadAttachementAvailable = [].includes(roleId);
  const isLinkAvailable = [
    ADMIN,
    SALES_REP,
    SALES_MANAGER,
    SALES_SUPPORT
  ].includes(roleId);

  const { productInOrderFor, msaEContractBA, channelName } = orderData;

  const isTQChannel = channelName === 'TQ';

  const isSendContractAllowedWithTQ =
    productInOrderFor === esChat ? msaEContractBA === no : isTQChannel;

  const getRow = (name, label) =>
    links[name] ? (
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <div>{label}</div>
        <div>
          <Button
            icon={Download}
            onPress={() => window.open(links[name], '_blank')}
            accessibilityLabel="Download"
            variant={{ text: true }}
          />
        </div>
      </li>
    ) : null;

  const linkSignedPdf =
    isLinkAvailable && getRow('contractSignedPdf', contractSignedPdf);

  return (
    <>
      <>
        <Divider space={2} variant={{ inverse: true }} />
        <Typography heading="h2" variant={{ size: 'h2' }} block>
          {attachments}
        </Typography>
        <Divider space={2} variant={{ inverse: true }} />
        {[microsoft365, googleWorkspace].includes(productInOrderFor) && (
          <Notification variant={{ style: 'subtle' }}>
            <Typography>
              {/* Single inline span: Typography lays children out as flex items, which indents wrapped lines. */}
              <span>
                <strong>{NOTE}:</strong> {attachementNote}
              </span>
            </Typography>
          </Notification>
        )}
        {isSendContractAllowedWithTQ && (
          <div className="card" style={{ marginTop: '16px' }}>
            <div className="card-header">
              <Typography heading="h4" variant={{ size: 'h4' }} block>{`${
                !hideQuote ? `Quote/Contract pdf` : `Contract pdf`
              }`}</Typography>
            </div>
            <ul className="list-group list-group-flush">
              {!hideQuote && getRow('quotePdf', quotePdf)}
              {getRow('contractUnSigned', contractUnSigned) &&
                getRow('contractUnSigned', contractUnSigned)}
              {linkSignedPdf && linkSignedPdf}
            </ul>
          </div>
        )}
        <Attachements
          isUploadAvailable={uploadAttachementAvailable}
          orderData={orderData}
        />
      </>
    </>
  );
};

OrderAttachments.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      quotePdf: PropTypes.string,
      contractUnSigned: PropTypes.string,
      contractSignedPdf: PropTypes.string
    })
  ).isRequired,
  hideQuote: PropTypes.bool.isRequired
};

export default OrderAttachments;
